import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Home from './pages/Home';
import QuotePage from './pages/QuotePage';
import AdminLogin from './pages/admin/AdminLogin';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminQuotesPage from './pages/admin/AdminQuotesPage';
import AdminProjectsPage from './pages/admin/AdminProjectsPage';
import AdminProductsPage from './pages/admin/AdminProductsPage';
import AdminTestimonialsPage from './pages/admin/AdminTestimonialsPage';
import AdminSettingsPage from './pages/admin/AdminSettingsPage';

function ProtectedRoute({ children }) {
  const { admin } = useAuth();
  if (!admin) return <Navigate to="/admin/login" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/quote" element={<QuotePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute><Navigate to="/admin/dashboard" replace /></ProtectedRoute>
          } />
          <Route path="/admin/dashboard" element={
            <ProtectedRoute><AdminDashboard /></ProtectedRoute>
          } />
          <Route path="/admin/quotes" element={
            <ProtectedRoute><AdminQuotesPage /></ProtectedRoute>
          } />
          <Route path="/admin/projects" element={
            <ProtectedRoute><AdminProjectsPage /></ProtectedRoute>
          } />
          <Route path="/admin/products" element={
            <ProtectedRoute><AdminProductsPage /></ProtectedRoute>
          } />
          <Route path="/admin/testimonials" element={
            <ProtectedRoute><AdminTestimonialsPage /></ProtectedRoute>
          } />
          <Route path="/admin/settings" element={
            <ProtectedRoute><AdminSettingsPage /></ProtectedRoute>
          } />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;